@if (!editMode) {
  <div>
    @if (srcSet) {
      <video width="320" height="240" controls>
        <source [src]="videoSrc" type="video/mp4" />
      </video>
    }
  </div>
} @else {
  <mat-form-field [formGroup]="formGroup" class="form-container">
    <input type="text" formControlName="{{ fieldConfig.name }}" matInput #field [errorStateMatcher]="matcher" />
    @for (v of fieldConfig.validators; track v) {
      <mat-error>
        @if (condition(v)) {
          <span>{{ message(v) }}</span>
        }
      </mat-error>
    }
  </mat-form-field>
}
